import moment from 'moment';
import {
  DATEFORMAT,
  ERROR_MESSAGE_DATE,
  ERROR_MESSAGE_FILES,
  ERROR_MESSAGE_FORM,
  ERROR_MESSAGE_KM,
  ERROR_STATUS,
  ERROR_WARRANTY,
  VALIDATION_KM,
  VALIDATION_YEARS,
}
from './constants';


export const getValidYears = (years, actualYear) => {
  const result = [];
  for (let i = 0; i < years; i++) {
    const val = actualYear - i;
    result.push({'key': i, 'value': val, 'text': val});
  }
  return result;
};

export const getStartEndDate = () => {
  return {
    'start': moment().startOf('month').format(DATEFORMAT),
    'end': moment().endOf('month').format(DATEFORMAT),
  };
};

export const processFiles = (files) => {
  const formData = new FormData();
  files.forEach((element, index) => {
    const name = element.name;
    formData.append('file', element, name);
  });
  
  return formData;
};

export const validatEmptyFields = (fields) => {
  return fields.find((field) => field.length === 0);
};

export const validateStatus = (status, scopePermission) => {
  return (status && status.toUpperCase() === 'ENVIADO') ||
    (status && status.toUpperCase() === 'APROBADO') ||
    scopePermission ?
    true :
    false;
};


export const downloadLabel = (filename, text) => {
  const element = document.createElement('a');
  element.setAttribute('href', `data:text/plain;charset=utf-8, ${encodeURIComponent(text)}`);
  element.setAttribute('download', filename);

  element.style.display = 'none';
  document.body.appendChild(element);

  element.click();

  document.body.removeChild(element);
};

export const validateDate = (date) => {
  const MAX_DAYS_TO_UPDATE = 7;
  if (moment(date).isValid()) {
    const days = moment().diff(moment(date), 'days');
    return days <= MAX_DAYS_TO_UPDATE ? true : false;
  }
  return true;
};


export const handleErrorCPO = (data) => {
  const {description, endSaleDate, priceSale, enrollment, km, document} = data;
  let errorMessage = null;

  if (
    description.length < 5 ||
    !endSaleDate ||
    priceSale === '' ||
    enrollment === '' ||
    km === ''
  ) {
    errorMessage = ERROR_MESSAGE_FORM;
  } else if (km > VALIDATION_KM) {
    errorMessage = ERROR_MESSAGE_KM;
  } else if (
    moment()
      .add(-1, 'days')
      .diff(endSaleDate, 'years') > VALIDATION_YEARS
  ) {
    errorMessage = ERROR_MESSAGE_DATE;
  } else if (validatEmptyFields([document])) {
    errorMessage = ERROR_MESSAGE_FILES;
  }

  return {
    errorMessage,
    'error': errorMessage ? true : false,
  };
};


export const handleErrorWarranty = (data) => {
  const {km, document, endSaleDate, vehicleStatus} = data;
  
  let errorMessage = null;

  if (km === '' || (+km > 1000 && validatEmptyFields([document])) || endSaleDate === null) {
    errorMessage = `${ERROR_WARRANTY}\n${ERROR_MESSAGE_FILES}`;
  } else if (vehicleStatus === '') {
    errorMessage = `${ERROR_STATUS}`;
  }

  return {
    'errorMessageWarranty': errorMessage,
    'errorWarranty': errorMessage ? true : false,
  };
};


export const vehicleStatusContition = (props) => {
  const {vehicleStatus, dealerSale} = props.vehicle;

  if (vehicleStatus) {
    return vehicleStatus;
  } else if (dealerSale) {
    return 'VENDIDO';
  }
  return '';
};

export const vehicleStatusForField = (props) => {
  const {vehicleStatus, status} = props.vehicle;

  if (typeof vehicleStatus !== 'undefined' &&
      vehicleStatus === 'VENDIDO' &&
    status !== 'INGRESADO') {
    return true;
  }

  return false;
};
